export default "__VITE_ASSET__kHlzPamN__"